<template>
  <div class="columns">
    <div class="column" style="text-align:left;">
      <label class="label">Beschreibung</label>
      <VueTrix maxlength="255" v-model="text" placeholder="Beschreibung einfügen"  />
    </div>
  </div>
</template>

<script>
import VueTrix from "vue-trix";
export default {
  props: ['item'],
  components: {VueTrix},
  data() {
    return {
      text: "",
      actionId: null,
    }
  },
  watch: {
    text: {
      handler: "sendActionData"
    }
  },
  mounted() {
    // modify action
    if (this.item && this.item.actions) {
      this.item=this.item.actions[0]
      this.text = this.item.data.text;
      if (this.item.id) {
        this.actionId = this.item.id;
      }
      console.log('Component action show text.');
    }
  },
  methods: {
    sendActionData: function(value) {
      console.log('sendActionData')
      let actionData={type:1, data: {text: value}  }
      if (this.actionId) {
        actionData.id=this.actionId
      }
      this.$emit('setActionData',actionData)
    },
  },
}

</script>
